export default {
  ZERMATT: 'Zermatt',
  INTERNATIONAL: 'International',
  MATTERHORN_GLACIER_PARADISE: 'Matterhorn glacier paradise',
  SUNNEGGA_ROTHORN: 'Sunnegga-Rothorn',
  // MGB_GGB: 'MGB/GGB',
  INTERNATIONAL_SUMMER: 'International summer',
  INTERNATIONAL_WINTER: 'International winter',
};



// WEBPACK FOOTER //
// ./src/views/skidata/components/pools.js